import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { HHScore, Score, OutOf, Tooltip } from "./styles/hh-score-styles";

const HiringHubScore = ({ hhScore, isRecruiter }) => {
  const agencyTooltip =
    "Your HH score is unique to your company and is made up of the following metrics: interview rate, number of placements and number of reviews. These metrics are weighted and used to calculate this score. The purpose of this score is to provide employers with an independent view of your quality and performance.<br><br><strong>Please note, engagements with no submissions will negatively impact your score.</strong>";
  const employerTooltip =
    "The HH score is unique to each recruitment company and is made up of the following metrics: interview rate, number of placements and number of reviews. These metrics are weighted and used to calculate this score. The purpose of this score is to provide employers with an independent view of agency quality and performance.";

  return (
    <Fragment>
      <ReactTooltip
        html
        place="bottom"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="hh-score-tooltip"
      />
      <HHScore data-test-id="hh-score">
        HH Score <Score>{hhScore}</Score>
        <OutOf> out of 10</OutOf>
        <Tooltip
          data-tip={isRecruiter ? agencyTooltip : employerTooltip}
          data-for="hh-score-tooltip"
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </Tooltip>
      </HHScore>
    </Fragment>
  );
};

HiringHubScore.propTypes = {
  hhScore: PropTypes.number.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
};

export default HiringHubScore;
